import { Input, Label } from "reactstrap";

import CreatableInput from "@components/fields/react-select/creatable-input";
import InputField from "@components/fields/input-field";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const UpsertEmail = ({
    handleFileUpload,
    attachments,
    removeUploadedFile,
    isReply = false
}) => {
    const {
        control,
        formState: { errors }
    } = useFormContext();
    const { t } = useTranslation();
    return (
        <>
            {!isReply && (
                <InputField
                    label="Subject"
                    control={control}
                    errors={errors}
                    id="subject"
                    name="subject"/>
            )}
            <InputField
                label="To"
                required
                control={control}
                errors={errors}
                id="to"
                name="to"
                placeholder="Enter Receiver Email"/>
            {!isReply && (
                <>
                    <CreatableInput
                        control={control}
                        errors={errors}
                        label="CC"
                        id="cc"
                        errMsg={errors.cc ? "Please enter valid email" : ""}
                        name="cc"/>
                    <CreatableInput
                        control={control}
                        errors={errors}
                        label="BCC"
                        id="bcc"
                        errMsg={errors.bcc ? "Please enter valid email" : ""}
                        name="bcc"/>
                </>
            )}

            <div>
                <Label>{t("Attachments")}</Label>
                <Input
                    type="file"
                    id="attachment"
                    multiple
                    onChange={e => handleFileUpload(e.target.files)}/>
            </div>
            <div className="d-flex align-items-center my-1">
                {attachments.map((attachment) => (
                    <div className="d-flex align-items-baseline justify-content-between py-50 px-25 text-muted font-small-4">
                        <p className="font-small-2">{attachment.name}</p>
                        <i
                            className="mdi mdi-close font-small-3"
                            onClick={() => removeUploadedFile(attachment)}></i>
                    </div>
                ))}
            </div>
            <InputField
                type="textarea"
                label="Body"
                required
                id="body"
                name="body"
                control={control}
                errors={errors}
                placeholder="Enter Body"/>
        </>
    );
};

export default UpsertEmail;
